/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Listings {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List Portals.
   *
   * @tags Listings
   * @name ListPortals
   * @summary List Portals
   * @request GET:/api/listings/portals
   * @secure
   */
  listPortals = (query, params = {}) =>
    this.http.request({
      path: `/api/listings/portals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Portal.
   *
   * @tags Listings
   * @name CreatePortal
   * @summary Create Portal
   * @request POST:/api/listings/portals
   * @secure
   */
  createPortal = (data, params = {}) =>
    this.http.request({
      path: `/api/listings/portals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create Syndications.
   *
   * @tags Listings
   * @name CreateSyndications
   * @summary Create Syndications
   * @request POST:/api/listings/{listing_id}/syndications
   * @secure
   */
  createSyndications = (listingId, data, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/syndications`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Syndications.
   *
   * @tags Listings
   * @name ListSyndications
   * @summary List Syndications
   * @request GET:/api/listings/{listing_id}/syndications
   * @secure
   */
  listSyndications = (listingId, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/syndications`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Sync Syndication.
   *
   * @tags Listings
   * @name SyncSyndication
   * @summary Sync Syndication
   * @request POST:/api/listings/{listing_id}/syndications/{syndication_id}/sync
   * @secure
   */
  syncSyndication = (listingId, syndicationId, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/syndications/${syndicationId}/sync`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Delete / disable syndication for a listing.
   *
   * @tags Listings
   * @name DeleteSyndication
   * @summary Delete Syndication
   * @request DELETE:/api/listings/{listing_id}/syndications/{syndication_id}
   * @secure
   */
  deleteSyndication = (listingId, syndicationId, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/syndications/${syndicationId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Get Listing Analytics.
   *
   * @tags Listings
   * @name GetListingAnalytics
   * @summary Get Listing Analytics
   * @request GET:/api/listings/{listing_id}/analytics
   * @secure
   */
  getListingAnalytics = (listingId, query, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/analytics`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description List listings for the organization.
   *
   * @tags Listings
   * @name ListListings
   * @summary List Listings
   * @request GET:/api/listings
   * @secure
   */
  listListings = (params = {}) =>
    this.http.request({
      path: `/api/listings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new listing for a property.
   *
   * @tags Listings
   * @name CreateListing
   * @summary Create Listing
   * @request POST:/api/listings
   * @secure
   */
  createListing = (data, params = {}) =>
    this.http.request({
      path: `/api/listings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Archive a listing and create a fresh successor (new price/terms generation).
   *
   * @tags Listings
   * @name RelistListing
   * @summary Relist Listing
   * @request POST:/api/listings/{listing_id}/relist
   * @secure
   */
  relistListing = (listingId, data, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/relist`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Full listing timeline for a property (newest first).
   *
   * @tags Listings
   * @name GetListingHistory
   * @summary Get Listing History
   * @request GET:/api/listings/property/{property_id}/history
   * @secure
   */
  getListingHistory = (propertyId, params = {}) =>
    this.http.request({
      path: `/api/listings/property/${propertyId}/history`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve a listing by ID.
   *
   * @tags Listings
   * @name GetListing
   * @summary Get Listing
   * @request GET:/api/listings/{listing_id}
   * @secure
   */
  getListing = (listingId, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update listing details.
   *
   * @tags Listings
   * @name UpdateListing
   * @summary Update Listing
   * @request PUT:/api/listings/{listing_id}
   * @secure
   */
  updateListing = (listingId, data, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a listing.
   *
   * @tags Listings
   * @name DeleteListing
   * @summary Delete Listing
   * @request DELETE:/api/listings/{listing_id}
   * @secure
   */
  deleteListing = (listingId, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Publish a listing.
   *
   * @tags Listings
   * @name PublishListing
   * @summary Publish Listing
   * @request POST:/api/listings/{listing_id}/publish
   * @secure
   */
  publishListing = (listingId, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/publish`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Bulk Update Status.
   *
   * @tags Listings
   * @name BulkUpdateStatus
   * @summary Bulk Update Status
   * @request POST:/api/listings/bulk/status
   * @secure
   */
  bulkUpdateStatus = (data, params = {}) =>
    this.http.request({
      path: `/api/listings/bulk/status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve all contact inquiries submitted for a specific listing.
   *
   * @tags Listings
   * @name ListListingContacts
   * @summary List contact inquiries for a listing
   * @request GET:/api/listings/{listing_id}/contacts
   * @secure
   */
  listListingContacts = (listingId, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/contacts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update contact inquiry lifecycle state (e.g. mark CONTACTED or CONVERTED).
   *
   * @tags Listings
   * @name UpdateListingContact
   * @summary Update contact inquiry status and response timestamp
   * @request PATCH:/api/listings/{listing_id}/contacts/{contact_id}
   * @secure
   */
  updateListingContact = (listingId, contactId, data, params = {}) =>
    this.http.request({
      path: `/api/listings/${listingId}/contacts/${contactId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
